<template>
    <BaseInputSelect
        v-model="formValues.risk_tolerance"
        name="risk_tolerance.risk_tolerance"
        :required="isRequiredLegalComplianceProfileAttribute('risk_tolerance', 'risk_tolerance')"
        :options="riskToleranceOptions"
        :label="$t('risk_tolerance.label_legal')"></BaseInputSelect>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { enumToSelectOptions } from '../../../../../utilities/helpers'
import { RiskToleranceOption } from '../../../../../typings'
import BaseInputSelect from '../../../../base/BaseInputSelect.vue'
import { TaxResidency } from '../../../../../utilities/account/useAccountDataPersonal'
import {
    getLegalWidgetFormValidationRules,
    initializeLegalWidgetForm,
    isRequiredLegalComplianceProfileAttribute,
} from './forms'
import { useVModel } from '@vueuse/core'
const riskToleranceOptions = computed(() => {
    return enumToSelectOptions(RiskToleranceOption, 'risk_tolerance')
})

const props = defineProps<{
    modelValue: TaxResidency[]
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)
initializeLegalWidgetForm(getLegalWidgetFormValidationRules('risk_tolerance'))
</script>
